import React from 'react'

const ScoreResult = ({data, index}) => {
    let fullScore = data.map((item) => {
        return item.value;
    });
    fullScore = fullScore.reduce((a, b) => a + b, 0);
    const result = data.filter((item) => {
        return item.id === index;
    });
    return (
        <div>
            <h2>{result[0] && (Math.round(result[0].value * 100 / fullScore))}%</h2>
            <h3>{result[0] && result[0].title}</h3>
        </div>
    )
}

export default ScoreResult;
